module.exports = __webpack_public_path__ + "static/img/白色大@2x.1bfa1cd6.png";